import { createContext } from "react";
import { ModalContextType } from "./type";

const defaultValue: ModalContextType = {
  modal: null,
  isOpen: false,
  openModal: () => {},
  closeModal: () => {},
  goToStep: () => {},
  goToNextStep: () => {},
  goToPreviousStep: () => {},
};

export const ModalContext = createContext<ModalContextType>(defaultValue);
